import type { Filter } from 'components/filters/useStreamFilters'
import { canonicalizeQuestFilter } from 'lib/questFilterCanonicalization'

export function isRadioStreamFilter(filter: Filter | null | undefined): boolean {
    const radioTeamId = typeof gon !== 'undefined' ? gon?.RADIO_TEAM_ID : null
    return Boolean(
        radioTeamId && filter?.team_ids?.some(teamId => String(teamId) === String(radioTeamId)),
    )
}

// The new-items pill only makes sense where the list is the activity-recency
// feed the watermark model describes (docs/feed-new-items-pill.md): following,
// public-ish scopes, or Radio, in default time order. Everything else —
// threads, search, notifications, history, starred, custom orders — keeps no pill.
export default function isNewItemsEligible(
    filter: Filter | null | undefined,
    loggedIn: boolean,
): boolean {
    if (!loggedIn || !filter) return false
    const effectiveFilter = canonicalizeQuestFilter(filter)
    if (effectiveFilter.questId) return false
    if (
        effectiveFilter.notifications ||
        effectiveFilter.history ||
        effectiveFilter.starred ||
        effectiveFilter.archived
    ) {
        return false
    }
    if (effectiveFilter.query) return false
    if (effectiveFilter.order !== 'time') return false
    return Boolean(
        effectiveFilter.following ||
            effectiveFilter.public ||
            effectiveFilter.market_cards ||
            effectiveFilter.treechat ||
            isRadioStreamFilter(effectiveFilter),
    )
}

// Only the station's unfiltered, chronological stream follows the broadcast.
export function isLiveRadioStream(filter: Filter | null | undefined): boolean {
    return Boolean(
        isRadioStreamFilter(filter) && !filter?.search && isNewItemsEligible(filter, true),
    )
}
